export const RowHighlightColors = {
  ON: 'bg-surface-status-info',
  OFF: 'bg-transparent',
}

export const highlightRowBasedOnId = (id?: string): void => {
  const elements = Array.from(document.querySelectorAll('tr'))

  if (elements?.length) {
    elements.forEach(el => {
      el.classList.remove(RowHighlightColors.ON)
    })
  }

  if (!id) return

  const element = document.getElementById(id)
  if (element) {
    const parentWithClass = element.closest('tr')
    if (parentWithClass) {
      parentWithClass.classList.add(RowHighlightColors.ON)
    }
  }
}
